import React, { useEffect, useRef, useState } from "react";
import { Carousel } from "antd";
import { dataList } from "./profit";

export default function IncomeTable() {
  const [list] = useState(dataList);

  /** 是否滚动 */
  const [isScrolle, setIsScrolle] = useState(true);

  /** 滚动速度，值越小，滚动越快 */
  const speed = 1500;
  const warper = useRef();
  /** 原数据 */
  const childDom1 = useRef();
  /** 拷贝数据 */
  const childDom2 = useRef();

  const childLi = useRef();

  // 开始滚动
  useEffect(() => {
    let timer;
    window.addEventListener("resize", handleResize);
    console.log(childLi?.current?.clientHeight);
    // 多拷贝一层，让它无缝滚动
    childDom2.current.innerHTML = childDom1.current.innerHTML;
    seamlessScrolling(timer);
  }, [isScrolle]);

  const handleResize = (timer) => {
    clearTimeout(timer);
    seamlessScrolling(timer);
  };

  // 无缝滚动
  const seamlessScrolling = (timer) => {
    if (isScrolle) {
      timer = setInterval(() => {
        if (warper.current.scrollTop >= childDom1.current.scrollHeight) {
          warper.current.scrollTop = 0;
        } else {
          warper.current.scrollTop += childLi?.current?.clientHeight;
        }
      }, speed);
    }
    return () => {
      clearTimeout(timer);
    };
  };

  return (
    <>
      <div className="income">
        <div className="list">
          <span>
            总收益 <em>¥789.96元</em>
          </span>
          <span>
            昨日收益 <em>¥58.2元</em>
          </span>
          <span>
            本月收益 <em>¥443.67元</em>
          </span>
        </div>
        <div className="income-list">
          <div className="header">
            <span>序号</span>
            <span>日期</span>
            <span>收益</span>
          </div>
          <div className="parent" ref={warper}>
            <div className="child" ref={childDom1}>
              {list.map((item, index) => (
                <li key={index} ref={childLi}>
                  <span>{index}</span>
                  <span>{item.date}</span>
                  <span>￥{item.userFee}元</span>
                </li>
              ))}
            </div>
            <div className="child" ref={childDom2}></div>
          </div>
        </div>
      </div>
    </>
  );
}
